import React from 'react';
import { arrayOf, shape, string, number } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import i18next from 'i18next';

import OrderActions from '~redux/Order/actions';
import CoreActions from '~redux/Core/actions';
import LocalStorageService from '~services/LocalStorageService';
import { getStoreOptions } from '~model/stores';
import { ORDER_STATUS } from '~constants/orders';

function StoreSelector({ stores, storeSelected }) {
  const dispatch = useDispatch();
  const { adminUser } = useSelector((state) => state.adminUser);
  const ordersFilter = useSelector((state) => state.order.ordersFilter);

  const onChange = (e) => {
    const storeValue = parseInt(e.target.value);
    LocalStorageService.setStoreSelected(storeValue);
    dispatch(CoreActions.setStoreSelected(storeValue));
    dispatch(OrderActions.getQuantityOrders(storeValue));
    if (!ordersFilter.includes(ORDER_STATUS.PRODUCTS)) {
      dispatch(OrderActions.getOrders(storeValue, ordersFilter));
    }
  };

  return (
    <FormControl
      sx={{
        width: '100%',
        height: '40px',
        maxWidth: '280px',
        justifySelf: 'flex-start'
      }}>
      <InputLabel id="store">{i18next.t('StoreSelector:title')}</InputLabel>
      <Select
        labelId="store"
        value={storeSelected}
        label={i18next.t('StoreSelector:title')}
        size="small"
        onChange={onChange}>
        {getStoreOptions(stores.page, adminUser.storeIds)?.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

StoreSelector.propTypes = {
  stores: shape({
    page: arrayOf(shape({ id: number.isRequired, name: string.isRequired }))
  }),
  storeSelected: number
};

export default StoreSelector;
